import { useRouteMatch } from 'react-router-dom'

const useAdAccountRouteMatch = () => useRouteMatch('/:accountId(\\d+)/*')

export default useAdAccountRouteMatch
